import { IconSvgProps } from "../types";

export const Checkmark = ({ size }: IconSvgProps) => (
    <svg
        fill="none"
        stroke="currentColor"
        version="1.2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 30"
        width={size}
        height={size}
    >
        <path d="m1.5 16.4c1.8-1.7 4.2-0.3 4.2-0.3l5.6 5.9 15.4-18.7c0 0 1.7-1.2 3.5 0.1 1.9 1.4 0.8 3.6 0.8 3.6l-18 22h-2l-9.1-8.7c0 0-2.1-2.2-0.4-3.9z" />
    </svg>
);
